'use client';
import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { BaseErrorPage } from '@/common/errors/BaseErrorPage';
import { UpdateIcon } from '@/common/icons';

export const FeatureUpdatesPage: FC = () => {
  const { t } = useTranslation();
  return (
    <BaseErrorPage
      title={t('maintenance:featureUpdatesPage:title')}
      description={t('maintenance:featureUpdatesPage:description')}
      icon={<UpdateIcon width={48} height={48} />}
    />
  );
};
